import KogAutoCompleteOutlinedControlled from "@/main/components/shared/inputAutoComplete/autoCompleteOutlinedControlled";
import { useFormContext, useWatch } from "react-hook-form";
import { useWarehouseReducer } from "@/main/store/warehouse";
import { getTranslateByKey } from "@/main/services/utils";
import { QuoteSupplierItemPartResponse } from "@/main/models/response";
import * as S from "../../styles";

interface IWarehouseInputProps {
	fieldPrefix: string;
	showFieldWithouEdit?: boolean;
	row: QuoteSupplierItemPartResponse;
}

export default function ColumnWarehouse({ fieldPrefix, showFieldWithouEdit, row }: IWarehouseInputProps) {
	const { control, setValue } = useFormContext();
	const { warehouse: warehouseReducer } = useWarehouseReducer();

	const watcherNotQuote = useWatch({
		control,
		name: `${fieldPrefix}.notQuote`,
		defaultValue: false,
	});

	if (row.isInventoryResponse || showFieldWithouEdit) {
		return <S.EllipsisCell title={row.warehouseName}>{row.warehouseName}</S.EllipsisCell>;
	}

	const hasDisabled = watcherNotQuote || warehouseReducer?.data?.length === 1;

	return (
		<KogAutoCompleteOutlinedControlled
			id="id-createAnswer-txt-warehouseName"
			nameCustom={`${fieldPrefix}.warehouseName`}
			placeholder={getTranslateByKey("information.warehouse")}
			label=""
			isDefaultValueUnique={!watcherNotQuote}
			disabledMessage
			control={control}
			hideValue={watcherNotQuote}
			disabled={hasDisabled}
			setValueCustom={setValue}
			rulesCustom={{ required: !watcherNotQuote }}
			options={warehouseReducer.data}
			isLoading={warehouseReducer.isLoading}
			onChangeCustom={() => {}}
		/>
	);
}
